module.exports = __webpack_public_path__ + "static/media/bg.f93cd90b.png";